import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import CssBaseline from '@material-ui/core/CssBaseline'
import TextField from '@material-ui/core/TextField'
import { Link } from 'react-router-dom'
import Grid from '@material-ui/core/Grid'
import LockOutlinedIcon from '@material-ui/icons/LockOutlined'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'

import api from '../../config/api'

import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup';

import { ErrorMessage } from './styles'
import React, { useEffect, useState } from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core'
import { toast } from 'react-toastify'

import { useHistory } from 'react-router-dom'



const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
        color: '#FFF',
        fontSize: 20,
        fontWeight: 600
    },
}));



const FormSchema = yup.object().shape({
    email:
        yup.string()
            .required('E-mail não inserido')
            .matches(/^[a-zA-Z0-9_.-]+@sicredi+.com+.br+$/i, 'E-mail mal formatado')
    ,
    password: yup.string()
        .required('Senha é obrigatória')
        .min(6, 'A senha deve conter pelo menos 6 caracteres'),
    passwordConfirm: yup.string()
        .required('Confirmação de senha é obrigatória')
        .oneOf([yup.ref('password'), null], 'As senhas devem corresponder'),
    branch_id: yup.number()
        .required('Selecione a sua agência')
        .default(1)

});


interface IFormInputs {
    email: string,
    password: string,
    passwordConfirm: string,
    branch_id: number
}

interface IBranchResponse {
    branchs: IBranch[]

}

interface IBranch {
    id: number,
    description: string
}


export default function SignUp() {

    const classes = useStyles();
    const { register, handleSubmit, formState: { errors } } = useForm<IFormInputs>({
        resolver: yupResolver(FormSchema)
    });

    const [branchs, setBranchs] = useState<IBranch[]>([])
    const history = useHistory()


    useEffect(() => {
        async function fetch() {
            const responseBranchs = await api.get<IBranchResponse>('/branchs')
            const { branchs } = responseBranchs.data
            setBranchs(branchs)
        }
        fetch()

    }, [])



    const handleSubmitForm = async (data: IFormInputs) => {
        try {
            await api.post('users', { ...data })
            toast.success("Usuário registrado com sucesso! 😀")
            history.push('login')
        } catch (err) {
        if(err instanceof Error){
            if (err.message = 'User already registred')
                toast.error('Este usuário já foi registrado!')
        }
        else{
                toast.error('Ocorreu algum erro!')
            }      
        }
    };

    return (
        <Container component="main" maxWidth="xs" >
            <CssBaseline />

            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Registre-se
                </Typography>

                <form className={classes.form} onSubmit={handleSubmit(handleSubmitForm)} >
                    <Grid container spacing={2}>
                        <Grid item xs={12} >
                            <TextField
                                autoComplete="fname"
                                variant="outlined"
                                fullWidth
                                {...register('email')}
                                error={errors.email ? true : false}
                                id="email"
                                label="E-mail"
                                autoFocus
                            />
                            {errors.email && <ErrorMessage>{errors.email.message}</ErrorMessage>}
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                id="password"
                                label="Senha"
                                {...register('password')}
                                error={errors.password ? true : false}
                                name="password"
                                type="password"
                                autoComplete="current-password"
                            />
                            {errors.password && <ErrorMessage>{errors.password.message}</ErrorMessage>}
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                label="Confirme a senha"
                                {...register('passwordConfirm')}
                                error={errors.passwordConfirm ? true : false}
                                type="password"
                                id="passwordConfirm"
                                autoComplete="current-password"
                            />
                            {errors.passwordConfirm && <ErrorMessage>{errors.passwordConfirm.message}</ErrorMessage>}
                        </Grid>
                        <Grid item xs={12}>
                            <FormControl variant="outlined" style={{ width: '100%' }}>
                                <InputLabel id="demo-simple-select-outlined-label">Agência</InputLabel>
                                <Select
                                    labelId="demo-simple-select-outlined-label"
                                    id="demo-simple-select-outlined"
                                    label="Agência"
                                    error={errors.branch_id ? true : false}
                                    defaultValue={1}
                                    {...register('branch_id')}
                                >
                                    {
                                        branchs.map(branch =>
                                            <MenuItem value={branch.id} key={branch.id} >
                                                {branch.description}
                                            </MenuItem>
                                        )
                                    }
                                </Select>
                            </FormControl>
                            {errors.branch_id && <ErrorMessage>{errors.branch_id.message}</ErrorMessage>}
                        </Grid>
                    </Grid>
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        Registrar
                    </Button>
                    <Grid container justify="flex-end">
                        <Grid item>
                            <Link to="/login" style={{
                                textDecoration: 'none',
                                color: '#64c832'
                            }}>
                                Já tem uma conta ? Faça login!
                           </Link>
                        </Grid>
                    </Grid>
                </form>
            </div>
        </Container>
    );
}
